/* PASARELA — comportamiento
   Cuatro puestos y diez camisas. Todo sale de UN numero, `activo`:
     centro = activo | derecha = activo+1 | atras = activo+2
     izquierda = activo-1 | el resto = guardadas y transparentes

   Una flecha mueve ese numero en uno. No hay que mover nada mas: los
   puestos se recalculan y el navegador interpola. Por eso el fondo, el
   nombre, las cuatro camisas y los desenfoques llegan todos en el mismo
   cuadro. Eso es lo que hace que se sienta como UN movimiento.

   El candado de 650 ms existe porque los puestos salen de un solo numero:
   un segundo clic a mitad de vuelo reapunta las diez desde donde esten y
   llegan desordenadas. */
(function () {
  "use strict";

  var hero = document.querySelector("[data-pasarela-raiz]");
  if (!hero) { return; }

  var caja = hero.querySelector("[data-psl-datos]");
  var items;
  try { items = JSON.parse(caja.textContent); } catch (e) { return; }
  if (!items || items.length < 4) { return; }

  var MS = 650;
  var reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
  var chico = function () { return matchMedia("(max-width: 760px)").matches; };

  /* ── Colores del texto ────────────────────────────────────────
     Hay DOS textos y cada uno tiene su regla.

     1. El bloque de abajo (titular, liga, precio) va BLANCO siempre, en
        los diez equipos. Antes se elegia solo y en los fondos claros salia
        negro: se leia, pero el hero se veia distinto en cada camisa y
        perdia unidad.

        Para que el blanco no se pierda cuando el fondo aclara, lo que se
        calcula ahora es el VELO. Se mide que tan claro es el color de
        abajo y se oscurece lo justo para que el blanco pase 4,5:1, ni un
        punto mas, para no ensuciar los degradados que ya eran oscuros.

     2. El nombre gigante del fondo NO puede ser blanco siempre. Vive a un
        22% de la altura, arriba del todo, donde el velo todavia es
        transparente — el velo cubre de la mitad para abajo, que es donde
        esta el texto que importa. Si arriba hay blanco (Saprissa lo tiene)
        un contorno blanco sobre blanco no se ve: desaparece la palabra
        DEPORTIVO SAPRISSA y el hero queda vacio.

        Asi que ese, y solo ese, se sigue midiendo: blanco sobre fondo
        oscuro, tinta oscura sobre fondo claro. Como es texto grande le
        basta 3:1. */
  function canales(hex) {
    return [1, 3, 5].map(function (i) { return parseInt(hex.substr(i, 2), 16); });
  }
  function luz(rgb) {
    var v = rgb.map(function (c) {
      c = c / 255;
      return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
    });
    return 0.2126 * v[0] + 0.7152 * v[1] + 0.0722 * v[2];
  }

  /* Para que el blanco (luz 1) llegue a 4,5:1 el fondo tiene que quedar
     por debajo de 1,05/4,5 menos 0,05 = 0,1833 de luz. Un velo negro al
     alfa a multiplica cada canal por (1-a), y en luz eso es mas o menos
     (1-a) elevado a 2,4. De ahi se despeja el alfa y se le suma margen. */
  var TECHO = 0.1833;
  function velo(hex) {
    var L = luz(canales(hex));
    var a = 0;
    if (L > TECHO) { a = 1 - Math.pow(TECHO / L, 1 / 2.4) + 0.08; }
    if (a < 0.26) { a = 0.26; }
    if (a > 0.78) { a = 0.78; }
    return "rgba(0,0,0," + a.toFixed(2) + ")";
  }

  /* El color a la altura donde cae el nombre gigante. Medir contra c1 a
     secas seria mas pesimista que lo que se ve en pantalla. */
  function mezcla(c1, c2, t) {
    var a = canales(c1), b = canales(c2);
    return a.map(function (v, i) { return v * (1 - t) + b[i] * t; });
  }
  function tintaAlta(c1, c2) {
    return (1.05 / (luz(mezcla(c1, c2, 0.22)) + 0.05)) >= 3 ? "#FFFFFF" : "#12100A";
  }

  items = items.map(function (e) {
    return {
      nombre: e.nombre, url: e.url, liga: e.liga, temporada: e.temporada, precio: e.precio,
      c1: e.c1, c2: e.c2,
      fondo: "linear-gradient(168deg, " + e.c1 + " 0%, " + e.c2 + " 100%)",
      alta: tintaAlta(e.c1, e.c2),
      baja: "#FFFFFF",
      velo: velo(e.c2)
    };
  });

  var N = items.length;
  var activo = 0, girando = false, reloj = null;

  var capas = hero.querySelectorAll(".psl-capa");
  var capaViva = 0, fondoActual = null;
  var rotulo = hero.querySelector(".psl-nombre b");
  var titulo = hero.querySelector(".psl-nombre");
  var ficha = hero.querySelector("[data-psl-ficha]");
  var ver = hero.querySelector("[data-psl-ver]");
  var puntos = hero.querySelectorAll("[data-psl-punto]");
  var caras = hero.querySelectorAll("[data-psl-item]");
  var pista = hero.querySelector("[data-psl-pista]");

  function puesto(i) {
    if (i === activo) { return "centro"; }
    if (i === (activo + 1) % N) { return "derecha"; }
    if (i === (activo + N - 1) % N) { return "izquierda"; }
    if (i === (activo + 2) % N) { return "atras"; }
    return "guardada";
  }

  function estilo(rol) {
    var m = chico();
    switch (rol) {
      case "centro":
        return { transform: "translateX(-50%)", filter: "blur(0px)", opacity: 1, zIndex: 20,
                 left: "50%", height: m ? "40%" : "56%", bottom: m ? "30%" : "26%" };
      case "izquierda":
        return { transform: "translateX(-50%)", filter: "blur(2px)", opacity: 0.85, zIndex: 10,
                 left: m ? "15%" : "21%", height: m ? "15%" : "24%", bottom: m ? "40%" : "31%" };
      case "derecha":
        return { transform: "translateX(-50%)", filter: "blur(2px)", opacity: 0.85, zIndex: 10,
                 left: m ? "85%" : "79%", height: m ? "15%" : "24%", bottom: m ? "40%" : "31%" };
      case "atras":
        return { transform: "translateX(-50%)", filter: "blur(4px)", opacity: 0.9, zIndex: 5,
                 left: "50%", height: m ? "12%" : "19%", bottom: m ? "42%" : "33%" };
      default:
        return { transform: "translateX(-50%) scale(.9)", filter: "blur(6px)", opacity: 0, zIndex: 1,
                 left: "50%", height: m ? "12%" : "19%", bottom: m ? "42%" : "33%" };
    }
  }

  function pintar(primera) {
    var it = items[activo];

    if (it.fondo !== fondoActual) {
      fondoActual = it.fondo;
      var entra = capas[1 - capaViva];
      entra.style.background = it.fondo;
      if (primera) {
        entra.style.transition = "none";
        entra.classList.add("is-on");
        void entra.offsetWidth;
        entra.style.transition = "";
      } else {
        entra.classList.add("is-on");
        capas[capaViva].classList.remove("is-on");
      }
      capaViva = 1 - capaViva;
    }

    hero.style.setProperty("--c1", it.c1);
    hero.style.setProperty("--c2", it.c2);
    hero.style.setProperty("--tinta", it.baja);
    hero.style.setProperty("--tinta-alta", it.alta);
    hero.style.setProperty("--velo", it.velo);

    Array.prototype.forEach.call(caras, function (el, i) {
      var s = estilo(puesto(i)), k;
      for (k in s) { if (Object.prototype.hasOwnProperty.call(s, k)) { el.style[k] = s[k]; } }
      el.setAttribute("aria-label", i === activo
        ? "Ver la camiseta del " + it.nombre
        : "Traer al frente la camiseta del " + items[i].nombre);
      el.tabIndex = puesto(i) === "guardada" ? -1 : 0;
    });

    ficha.innerHTML = "<span>" + it.liga + "</span><span>" + it.temporada +
                      "</span><b>Desde " + it.precio + "</b>";
    if (ver) { ver.setAttribute("href", it.url); }

    Array.prototype.forEach.call(puntos, function (d, i) {
      d.classList.toggle("is-on", i === activo);
      d.setAttribute("aria-selected", String(i === activo));
    });
  }

  function nombre(txt, animado) {
    function poner() {
      rotulo.textContent = txt;
      titulo.style.setProperty("--n", String(txt.length));
    }
    if (!animado || reduce) { poner(); return; }
    titulo.classList.add("is-cambiando");
    setTimeout(function () { poner(); titulo.classList.remove("is-cambiando"); }, 260);
  }

  function irA(i, porMano) {
    if (girando || i === activo) { return; }
    girando = true;
    activo = ((i % N) + N) % N;
    pintar();
    nombre(items[activo].nombre, true);
    if (porMano !== false) { reiniciarReloj(); }
    setTimeout(function () { girando = false; }, MS);
  }

  hero.addEventListener("click", function (e) {
    var f = e.target.closest("[data-psl-ir]");
    if (f) { irA(activo + Number(f.getAttribute("data-psl-ir"))); return; }
    var d = e.target.closest("[data-psl-punto]");
    if (d) { irA(Number(d.getAttribute("data-psl-punto"))); return; }
    var c = e.target.closest("[data-psl-item]");
    if (c) {
      var i = Number(c.getAttribute("data-psl-item"));
      if (i === activo) { location.href = items[activo].url; }
      else { irA(i); }
    }
  });

  hero.addEventListener("keydown", function (e) {
    if (e.key === "ArrowRight") { irA(activo + 1); }
    else if (e.key === "ArrowLeft") { irA(activo - 1); }
  });

  (function () {
    var x0 = null, y0 = 0;
    if (!pista) { return; }
    pista.addEventListener("pointerdown", function (e) { x0 = e.clientX; y0 = e.clientY; }, { passive: true });
    pista.addEventListener("pointerup", function (e) {
      if (x0 === null) { return; }
      var dx = e.clientX - x0, dy = e.clientY - y0;
      x0 = null;
      if (Math.abs(dx) > 44 && Math.abs(dx) > Math.abs(dy) * 1.5) {
        irA(activo + (dx < 0 ? 1 : -1));
      }
    }, { passive: true });
    pista.addEventListener("pointercancel", function () { x0 = null; }, { passive: true });
  })();

  var visible = true;
  if (window.IntersectionObserver) {
    new IntersectionObserver(function (es) { visible = es[0].isIntersecting; }, { threshold: 0.35 }).observe(hero);
  }
  function reiniciarReloj() {
    if (reloj) { clearInterval(reloj); }
    if (reduce) { return; }
    reloj = setInterval(function () {
      if (!visible || document.hidden || girando) { return; }
      irA(activo + 1, false);
    }, 5200);
  }

  var anchoAntes = window.innerWidth;
  addEventListener("resize", function () {
    if (window.innerWidth !== anchoAntes) { anchoAntes = window.innerWidth; pintar(); }
  }, { passive: true });

  pintar(true);
  nombre(items[0].nombre, false);
  reiniciarReloj();
})();
